import { ChangeDetectionStrategy, Component, ViewEncapsulation, model } from '@angular/core';

@Component({
    selector: 'fi-new-report-widget-name-description-editor',
    templateUrl: './fi-new-report-widget-name-description-editor.component.html',
    styleUrls: ['./fi-new-report-widget-name-description-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-new-report-widget-name-description-editor' },
    standalone: false,
})
export class FiNewReportWidgetNameDescriptionEditorComponent {
    public name = model.required<string>();
    public description = model.required<string>();
}
